const data = {
    words: [
        {
            answer: 'Эпителий',
            question: 'совокупность полярных дифференцированных клеток, тесно прилегающих друг к другу в виде пласта'
        },
        {
            answer: 'Пневмония',
            question: 'острое инфекционное заболевание, различное по этиологии (преимущественно бактериальное), характеризующееся очаговыми поражениями легких с внутриальвеолярной экссудацией'
        },
        {
            answer: 'Муколитик',
            question: 'лекарственное средство, которое разжижает мокроту и облегчают ее выведение из легких'
        },
        {
            answer: 'Эрдостеин',
            question: 'муколитическое средство, производное тиола'
        },
        {
            answer: 'Бронхография',
            question: 'метод рентгенологического исследования трахеи и бронхов после введения в их просвет рентгеноконтрастного вещества (йодолипол, пропилйодон и др.)'
        },
    ],
    lettersMap: {
        'Э': 1,
        'Д': 2,
        'О': 3,
        'М': 4,
        'А': 5,
        'Р': 6,
        'И': 7,
        'У': 8,
        'К': 9,
        'Л': 10,
        'Т': 11,
        'Н': 12,
        'В': 13,
        'Г': 14,
        'П': 15,
        'Е': 16,
        'Я': 17
    },
    result: 'Эдомари — муколитик нового поколения'
};

export default data;